import { render } from "./FRAPL01.vue?vue&type=template&id=48f8a232&ts=true"
import script from "./FRAPL01.vue?vue&type=script&lang=ts"
export * from "./FRAPL01.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/FormCodeList/FRAPL01.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48f8a232"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48f8a232', __exports__)) {
    api.reload('48f8a232', __exports__)
  }
  
  module.hot.accept("./FRAPL01.vue?vue&type=template&id=48f8a232&ts=true", () => {
    api.rerender('48f8a232', render)
  })

}


export default __exports__